<template>
  <div>
    <section>
      <b-col class="d-flex justify-content-end px-0 pt-25">
        <filter-wrapper
          :properties="selectedFilters"
          :width-offset="580"
          @clicked="openSelectedFilter"
          @cleared="clearFilters"
        />
        <b-dropdown
          ref="dateDropdown"
          menu-class="py-0 daterangepicker-menu"
          right
          class="mr-1"
          :disabled="isLoading"
          variant="outline-dark"
          size="sm"
          no-caret
        >
          <template #button-content>
            {{ dateRange }}
            <GjIcon
              name="Calendar"
              class="ml-50"
            />
            <b-button-close
              v-if="dateRangeSubmitted"
              class="ml-25 pb-25"
              @click.stop="clearDateRange"
            />
          </template>
          <div class="p-2">
            <date-range-picker
              :ranges="predefinedRanges"
              default-range-select="last7Days"
              :allow-compare="false"
              @submit="submitDateRange"
              @cancel="closeDropdown"
            />
          </div>
        </b-dropdown>
        <dropdown
          :title="$tk('ClientPortal.MasterTable.Filters')"
          class="mb-1 mr-1"
          :disabled="isLoading"
          :show-dropdown="showFilters"
          @change="toggleFilters"
        >
          <template #menu-items>
            <dropdown-submenu
              v-for="(filter, index) in model.filters"
              :key="filter.name + '-' + index"
              :input-id="filter.name"
              :text="filter.name"
              input-name="submenu"
              :selected-filter="selectedFilter(filter.name)"
              :checked="menu"
              @changeSelectedMenu="changeMenu"
            >
              <template #items>
                <dropdown-item v-if="filter.name !== 'Statuses'">
                  <b-form-input
                    v-model="model.serverParams.columnFilters[formatText(filter.name)]"
                    :type="filter.name === 'Amount'? 'number': 'text'"
                    class="__dropdown-input"
                    :placeholder="filter.name"
                    :disabled="onChange"
                    :formatter="correctFormat(model.serverParams.columnFilters[formatText(filter.name)], filter.name)"
                    @input="onInputChange(filter.name)"
                  />
                </dropdown-item>
                <template v-if="filter.name==='Statuses'">
                  <dropdown-item
                    v-for="(status, statusIndex) in model.statuses"
                    :key="status + '-' + statusIndex"
                    :label="status.text"
                    :filter-name="filter.name"
                    :value="status.value"
                    :menu-name="filter.name"
                    :selected="status.selected"
                    @change="includeOrExclude"
                  />
                </template>
                <template v-else>
                  <dropdown-item
                    v-for="(option, optionIndex) in filter.operators"
                    :key="option + '-' + optionIndex"
                    type="radio"
                    :label="option"
                    :filter-name="filter.name"
                    :selected="filter.selected"
                    :value="option"
                    :menu-name="filter.name"
                    @change="includeOrExclude"
                  />
                </template>
              </template>
              <template #footer>
                <dropdown-clear-item
                  :title="$tk('ClientPortal.Filters.Clear')"
                  @click="clearFilters(filter.name, false)"
                />
              </template>
            </dropdown-submenu>
            <dropdown-clear-item
              :title="$tk('ClientPortal.Filters.ClearAll')"
              @click="clearFilters"
            />
          </template>
        </dropdown>
        <SearchInputField
          :disabled="isLoading"
          :placeholder="$tk('Admin.Withdraws.SearchByAccountName')"
          @onInputSearch="onSearchChange"
        />
      </b-col>
      <b-card
        class="my-50 admin-table--management"
        no-body
      >
        <Table
          :data="allWithdraws"
          :columns="withdrawsColumns"
          :is-loading="isLoading"
          remote-mode
          class="admin-table__data"
          type-of-table="withdraws"
          @changePage="changeCurrentPage"
          @onSortChange="sort"
        />
        <b-modal
          id="approve-reject-withdraw-modal"
          ref="approvewithdrawAdModal"
          :title="$tk(modalTitle)"
          centered
          no-close-on-backdrop
          no-enforce-focus
          footer="footer"
          @show="loadEditWithdrawRequest"
        >

          <div>
            <div class="mb-1">
              <label>{{ $tk("ClientPortal.Admin.AccountId") }}:</label> <b>{{ editWithdrawRequest.info.accountId }}</b>
            </div>
            <div class="mb-1">
              <label>{{ $tk("ClientPortal.Admin.AccountName") }}:</label> <b>{{ editWithdrawRequest.info.accountName }}</b>
            </div>
            <div class="mb-1">
              <label>{{ $tk("ClientPortal.Admin.Amount") }}:</label> <b>{{ editWithdrawRequest.info.amount }}</b>
            </div>
            <div class="mb-1">
              <label>{{ $tk("ClientPortal.Admin.FilePath") }}:</label> <b>{{ editWithdrawRequest.info.filePath }}</b>
            </div>
            <div class="mb-2">
              <label>{{ $tk("ClientPortal.Admin.CreatedAt") }}:</label> <b>{{ editWithdrawRequest.info.insertDateTime }}</b>
            </div>
            <b-form-group
              :invalid-feedback="errors['RejectionMessage']"
              :label="$tk('ClientPortal.Form.RejectionReason') + ' *'"
            >
              <b-form-textarea
                v-if="editWithdrawRequest.type == 3"
                id="textarea-default"
                v-model="editWithdrawRequest.info.rejectionMessage"
                type="text"
                class="form-control"
                :placeholder="$tk('ClientPortal.Admin.WriteHere')"
                no-resize
                :state="errors['RejectionMessage'] == null ? null : false"
                @input="clearRejectionError"
              />
            </b-form-group>
          </div>

          <template #modal-footer="{ cancel, close }">
            <b-button
              class="m-0"
              size="sm"
              variant="outline-secondary"
              @click="cancel(),errors = {}"
            >
              {{ $tk('ClientPortal.Form.Actions.Cancel') }}
            </b-button>
            <b-button
              :variant="editWithdrawRequest.type == 3 ? 'danger': 'primary'"
              class="m-0 ml-1 float-right"
              size="sm"
              :disabled="editWithdrawRequest.loading"
              @click="updateWithdrawRequest(close)"
            >
              <span v-if="editWithdrawRequest.type == 1">
                {{ $tk("ClientPortal.Admin.Approve") }}
              </span>
              <span v-else-if="editWithdrawRequest.type == 2">
                {{ $tk("ClientPortal.Admin.Paid") }}
              </span>
              <span v-else>
                {{ $tk("ClientPortal.Admin.Reject") }}
              </span>
            </b-button>
          </template>
        </b-modal>
      </b-card>
    </section>
  </div>
</template>

<script>
import {
  computed,
  onMounted,
  ref,
  reactive,
} from '@vue/composition-api'
import store from '@/store'
import Table from '@/components/Table.vue'
import SearchInputField from '@/components/SearchInputField.vue'
import AccountAdminService from '@/api/admin/accountAdmin.service'
import notification from '@/mixins/toastification'
import Dropdown from '@/components/Dropdown.vue'
import DropdownItem from '@/components/DropdownItem.vue'
import DropdownSubmenu from '@/components/DropdownSubmenu.vue'
import DropdownClearItem from '@/components/DropdownClearItem.vue'
import FilterWrapper from '@/components/FilterWrapper.vue'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import DateRangePicker from '@/components/VueDateRangePicker'
import moment from 'moment'
import translation from '@/mixins/translate'
import { debounce } from 'vue-debounce'
import onSortChange from '@/mixins/onSortChange'

const WithdrawStatus = {
  Pending: 1,
  Confirmed: 2,
  Rejected: 3,
  Paid: 4,
}

export default {
  components: {
    Table,
    SearchInputField,
    Dropdown,
    DropdownItem,
    DropdownSubmenu,
    FilterWrapper,
    DropdownClearItem,
    DateRangePicker,
    GjIcon,
  },
  mixins: [notification],
  setup(_props, context) {
    const withdrawsColumns = [
      {
        label: translation.methods.$tk('ClientPortal.Admin.Ads.Id'),
        field: 'id',
        type: 'number',
        width: '100px !important',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Ads.AccountName'),
        field: 'accountName',
        width: '200px !important',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Ads.Amount'),
        field: 'amount',
        width: '150px !important',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Ads.BankAccountNumber'),
        field: 'bankAccountNumber',
        width: '150px !important',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Ads.BillNumber'),
        field: 'billNumber',
        width: '250px !important',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Ads.Message'),
        field: 'message',
        width: '270px !important',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Ads.FilePath'),
        field: 'filePath',
        width: '150px !important',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Ads.Status'),
        field: 'status',
        width: '150px !important',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.Ads.CreatedAt'),
        field: 'insertDateTime',
        type: 'date',
        dateInputFormat: 'dd/MM/yyyy HH:mm',
        dateOutputFormat: 'dd/MM/yyyy HH:mm',
        width: '250px !important',
      },
    ]
    const predefinedRanges = {
      today: {
        label: translation.methods.$tk('ClientPortal.PredefinedRanges.Today'),
        startDate: moment(),
        endDate: moment(),
      },
      yesterday: {
        label: translation.methods.$tk('ClientPortal.PredefinedRanges.Yesterday'),
        startDate: moment().subtract(1, 'days'),
        endDate: moment().subtract(1, 'days'),
      },
      last7Days: {
        label: translation.methods.$tk('ClientPortal.PredefinedRanges.Last7Days'),
        startDate: moment().subtract(7, 'days'),
        endDate: moment().subtract(1, 'days'),
      },
      last30Days: {
        label: translation.methods.$tk('ClientPortal.PredefinedRanges.Last30Days'),
        startDate: moment().subtract(30, 'days'),
        endDate: moment().subtract(1, 'days'),
      },
      lastMonth: {
        label: translation.methods.$tk('ClientPortal.PredefinedRanges.LastMonth'),
        startDate: moment().subtract(1, 'months').startOf('month'),
        endDate: moment().subtract(1, 'month').endOf('month'),
      },
    }
    const allWithdraws = computed(() => store.getters.allWithdraws)
    const model = computed(() => store.getters.getWithdrawModel)
    const errors = ref({})

    const isLoading = ref(false)
    const menu = ref('')
    const showFilters = ref(false)
    const selectedFilters = reactive([])
    const dateRange = ref(translation.methods.$tk('ClientPortal.DateRange.SelectDateRange'))
    const dateRangeSubmitted = ref(false)
    const onChange = ref(false)

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getWithdraws')
      isLoading.value = false
    })

    const formatText = name => name.charAt(0).toLowerCase() + name.slice(1)

    const prependZero = value => {
      if (value.toString().length === 1) {
        return `0${value}`
      }
      return value
    }

    const formatDate = value => {
      const day = prependZero(value.getDate())
      const month = prependZero(value.getMonth() + 1)
      const year = prependZero(value.getFullYear())

      return `${day}/${month}/${year}`
    }

    const getDateFromMomentRange = (startMoment, endMoment) => {
      const startDate = new Date(startMoment)
      const endDate = new Date(endMoment)
      return `${formatDate(startDate)} - ${formatDate(endDate)}`
    }

    const closeDropdown = () => {
      context.refs.dateDropdown.hide(true)
    }

    const clearDateRange = async () => {
      model.value.serverParams.dateRange = null
      dateRangeSubmitted.value = false
      dateRange.value = translation.methods.$tk('ClientPortal.DateRange.SelectDateRange')
      await store.dispatch('getFilteredWithdraws', model.value)
    }

    const changeCurrentPage = async value => {
      model.value.serverParams.page = value
      await store.dispatch('getFilteredWithdraws', model.value)
    }
    const sort = value => {
      onSortChange(value, model, 'getFilteredWithdraws')
    }
    const editWithdrawRequest = reactive({
      loading: true,
      type: 0,
      info: {},
    })

    const loadEditWithdrawRequest = () => {
      const data = computed(() => store.getters.editWithdrawRequest)
      editWithdrawRequest.loading = data.value.loading
      editWithdrawRequest.type = data.value.type
      editWithdrawRequest.info = data.value.info
    }

    const modalTitle = computed(() => {
      if (editWithdrawRequest.type === 1) return 'ClientPortal.Admin.AreYouSureYouWantToApproveThisWithdraw'
      if (editWithdrawRequest.type === 2) return 'ClientPortal.Admin.AreYouSureYouWantToMarkAsPaidThisWithdraw'
      return 'ClientPortal.Admin.AreYouSureYouWantToRejectThisWithdraw'
    })

    const updateWithdrawRequest = async closeCallback => {
      editWithdrawRequest.loading = true
      const status = () => {
        if (editWithdrawRequest.type === 1) return 'Confirmed'
        if (editWithdrawRequest.type === 2) return 'Paid'
        return 'Rejected'
      }
      const statusId = WithdrawStatus[status()]
      try {
        const response = await AccountAdminService.updateWithdrawRequest(editWithdrawRequest.info, statusId)
        if (response.saved) {
          notification.methods.success(response.message)
          errors.value = {}
          closeCallback()
        } else {
          errors.value = response.errors
          // notification.methods.error(response.message)
        }
      } catch (err) {
        notification.methods.error(err.message)
        closeCallback()
      } finally {
        await store.dispatch('getFilteredWithdraws', model.value)
        editWithdrawRequest.loading = false
      }
    }

    const onFilterChange = async () => {
      onChange.value = true
      await store.dispatch('getFilteredWithdraws', model.value)
      onChange.value = false
    }

    const changeMenu = newOpenedMenu => {
      menu.value === newOpenedMenu ? menu.value = '' : menu.value = newOpenedMenu
    }

    const correctFormat = (value, filter) => {
      if (filter === 'Amount' && !value) {
        model.value.serverParams.columnFilters[formatText(filter)] = '0'
      }
    }

    const updateSelectedFilters = (filter, count) => {
      const filterObj = selectedFilters.find(f => f.name === filter)
      if (filterObj) {
        if (count > 0) { filterObj.selectedFilters = count } else {
          const filterIndex = selectedFilters.findIndex(f => f.name === filter)
          selectedFilters.splice(filterIndex, 1)
        }
      } else {
        selectedFilters.push({ name: filter, selectedFilters: count })
      }
    }

    const updateStatuses = (filter, value) => {
      const { propertyFilters } = model.value.serverParams
      const selectedFilter = propertyFilters[filter]
      const optionIndex = selectedFilter.value.indexOf(value)
      const statusSelected = model.value.statuses.find(status => status.value === value)
      const { columnFilters } = model.value.serverParams
      if (optionIndex < 0) {
        selectedFilter.value.push(value)
        statusSelected.selected = true
        columnFilters[filter].push(value)
      } else {
        selectedFilter.value.splice(optionIndex, 1)
        statusSelected.selected = false
        columnFilters[filter].splice(optionIndex, 1)
        if (selectedFilter.value.length === 0 && columnFilters[filter].length === 0) {
          delete propertyFilters[filter]
          delete columnFilters[filter]
        }
      }
    }

    const updatePropertyFilter = (filter, value, operator) => {
      const { propertyFilters } = model.value.serverParams
      const selectedFilter = propertyFilters[filter]
      if (selectedFilter.operator === operator) {
        delete propertyFilters[filter]
      } else {
        selectedFilter.operator = operator
        selectedFilter.value = value.toString()
      }
    }

    const updatePropertyFilters = (filter, value, operator = null) => {
      const { propertyFilters } = model.value.serverParams
      const filterObject = formatText(filter)
      if (filterObject in propertyFilters) {
        if (filter === 'Statuses') {
          updateStatuses(filterObject, value)
        } else {
          updatePropertyFilter(filterObject, value, operator)
        }
      } else {
        propertyFilters[filterObject] = {
          operator,
          property: filter,
          value: filter === 'Statuses' ? [value] : value,
        }
        if (filter === 'Statuses') {
          const { columnFilters } = model.value.serverParams
          columnFilters[filterObject] = []
          columnFilters[filterObject].push(value)
        }
      }
      const count = filter === 'Statuses' ? propertyFilters[filterObject]?.value.length : 1
      updateSelectedFilters(filter, count)
    }

    const includeOrExclude = (filter, option) => {
      if (filter === 'Statuses') {
        const statusSelected = model.value.statuses.find(status => status.value === option)
        statusSelected.selected = !statusSelected.selected
        updatePropertyFilters(filter, option)
        onFilterChange()
      } else {
        const selectedOption = model.value.filters.find(f => f.name === filter)
        const { columnFilters } = model.value.serverParams
        selectedOption.selected === option ? selectedOption.selected = '' : selectedOption.selected = option
        updatePropertyFilters(filter, columnFilters[formatText(filter)], option)
        if (!columnFilters[formatText(filter)].toString()) { return }
        onFilterChange()
      }
    }

    const toggleFilters = (toogleFilter = null) => {
      menu.value = ''
      showFilters.value = toogleFilter ?? !showFilters.value
    }

    const clearFilters = (filter = null, closeAllDropdowns = true) => {
      const { propertyFilters } = model.value.serverParams
      const { columnFilters } = model.value.serverParams
      const { statuses } = model.value
      const { filters } = model.value
      if (!filter) {
        selectedFilters.splice(0, selectedFilters.length)
        filters.forEach(f => { f.selected = '' })
        Object.keys(propertyFilters).forEach(propertyFilter => { delete propertyFilters[propertyFilter] })
        Object.keys(columnFilters).forEach(columnFilter => { columnFilters[columnFilter] = null })
        statuses.forEach(status => { status.selected = false })
        filters.forEach(element => { element.selected = '' })
        toggleFilters(false)
      } else {
        const selectedFilter = model.value.filters.find(f => f.name === filter)
        const includedFilterIndex = selectedFilters.findIndex(f => f.name === filter)
        const filterObject = formatText(filter)
        columnFilters[filterObject] = null
        selectedFilters.splice(includedFilterIndex, 1)
        selectedFilter.selected = ''
        delete propertyFilters[filterObject]
        if (filter === 'Statuses') { statuses.forEach(status => { status.selected = false }) }
        if (closeAllDropdowns) { toggleFilters(false) }
      }
      onFilterChange()
      menu.value = ''
    }

    const onInputChange = debounce(filter => {
      const filterObject = formatText(filter)
      const { propertyFilters } = model.value.serverParams
      const { columnFilters } = model.value.serverParams
      if (filterObject in propertyFilters) {
        propertyFilters[filterObject].value = columnFilters[filterObject]
      } else { return }
      onFilterChange()
    }, 500)

    const submitDateRange = async range => {
      const { startDate, endDate } = range
      dateRangeSubmitted.value = true
      dateRange.value = getDateFromMomentRange(startDate, endDate)
      if (model.value.serverParams.dateRange !== dateRange.value) {
        model.value.serverParams.dateRange = dateRange.value
        await store.dispatch('getFilteredWithdraws', model.value)
      }
      closeDropdown()
    }

    const onSearchChange = async value => {
      model.value.serverParams.accountName = value
      if (!value) {
        await store.dispatch('getFilteredWithdraws', model.value)
      }
      await store.dispatch('getFilteredWithdraws', model.value)
    }

    const selectedFilter = name => {
      const filter = selectedFilters.findIndex(f => f.name === name)
      if (filter > -1) return true
      return false
    }

    const openSelectedFilter = filterName => {
      toggleFilters(true)
      menu.value = filterName
    }

    const clearRejectionError = () => { errors.value.RejectionMessage = null }

    window.onclick = e => {
      if (!e.path.find(x => x.className?.includes('dropdown'))) {
        toggleFilters(false)
        menu.value = ''
      }
    }

    return {
      allWithdraws,
      isLoading,
      changeCurrentPage,
      editWithdrawRequest,
      loadEditWithdrawRequest,
      modalTitle,
      updateWithdrawRequest,
      model,
      showFilters,
      menu,
      selectedFilters,
      changeMenu,
      includeOrExclude,
      clearFilters,
      toggleFilters,
      onInputChange,
      formatText,
      onSearchChange,
      predefinedRanges,
      submitDateRange,
      dateRange,
      closeDropdown,
      clearDateRange,
      dateRangeSubmitted,
      withdrawsColumns,
      sort,
      selectedFilter,
      openSelectedFilter,
      correctFormat,
      errors,
      onChange,
      clearRejectionError,
    }
  },
}
</script>
